import Payment from '@/model/Payment';
import React, { JSX } from 'react';
import CardClient from '@/model/CardClient';
import { CardCheckout } from '../types';
import { CardCheckoutContent } from './CardCheckoutContent';

interface StateProps {
  cards: CardClient[];
  payment: Payment;
  totalValue: number;
  card: CardCheckout;
}

interface DispatchProps {
  toCurrency: (value: number) => string;
  onCardSelected: (id: string) => void;
  onShowDeleteCreditCard: (cardId: string) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => void;
  validateCreditCard: () => void;
}

type Props = StateProps & DispatchProps;

export const CreditCardPaymentRequestContent: React.FC<Props> = ({
  cards,
  payment,
  totalValue,
  toCurrency,
  card,
  onCardSelected,
  onShowDeleteCreditCard,
  onChange,
  validateCreditCard,
}): JSX.Element => (
  <div className="w-full md:w-[411px] mt-[14px]">
    <div className="flex flex-col justify-between">
      <div className="space-y-5 ">
        {cards.length === 0 ? (
          <div className="text-base font-dmsans font-normal text-neutro-w-600">
            Você ainda não tem um cartão de crédito cadastrado
            <br />
            <br /> Clique no botão <strong>“Adicionar novo cartão”</strong> para cadastrar um cartão
            de crédito.
          </div>
        ) : (
          ''
        )}

        <CardCheckoutContent
          payment={payment}
          totalValue={totalValue}
          toCurrency={toCurrency}
          cards={cards}
          card={card}
          onCardSelected={onCardSelected}
          onShowDeleteCreditCard={onShowDeleteCreditCard}
          onChange={onChange}
          validateCreditCard={validateCreditCard}
        />
      </div>
    </div>
  </div>
);
